import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { updateAdditionalInfoAPI } from "../../adapters/dashboard/dashboardAdapater";
import DashboardContext from "../../context/dashboard/DashboardContext";
import { ConfirmCancel } from "../modal/dashboard/ConfirmCancel";
import {Spinner} from "reactstrap";
export function AdditionalInformation(props) {
  const { additionalInfo, estimateId, editDisabled } = props;
  const [showEdit, setShowEdit] = useState(false);
  const [progress, setProgress] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const [error, setError] = useState(null);
  const { handleSubmit, register, errors } = useForm();
  const dashboardContext = useContext(DashboardContext);
  const closeEdit = () => {
    setShowEdit(false);
    setConfirmCancel(false);
  };
  const submitFn = async (formData) => {
    setError(null);
    setProgress(true);
    const body = {
      estimate_id: estimateId,
      additional_info: formData["additional_info"],
    };
    try {
      const res = await updateAdditionalInfoAPI(body);
      if (res.data.meta.code === 200) {
        //successfully updated.
        setProgress(false);
        dashboardContext.updateStatus({
          status: "success",
          color: "success",
          message: "Additional Information Updated Successfully.",
        });
        dashboardContext.refresh();
        closeEdit();
      } else {
        dashboardContext.updateStatus({
          status: "error",
          color: "danger",
          message: "An Error Occurred, Please try again later.",
        });
        setProgress(false);
        setError("An error occurred, Please try again later.");
      }
    } catch (e) {
      setError("An error occurred, Please try again later.");
      setProgress(false);
      console.error("An Error occurred", e);
    }
  };
  const JSX = (
    <>
      <div className="move-additional-info-container">
        <div className="d-flex flex-row align-items-center justify-content-between my-4">
          <h3 className="m-0 mr-2">Additional Information</h3>
          {editDisabled === false && showEdit === false && (
            <button
              className="btn btn-dark btn-sm"
              type="button"
              onClick={() => {
                setShowEdit(true);
              }}
            >
              Edit Additional Info
            </button>
          )}
        </div>
        {showEdit === false && (
          <>
            <p className="details">
              {additionalInfo !== ""
                ? additionalInfo
                : "No Additional Information provided."}
            </p>
          </>
        )}
        {showEdit === true && (
          <>
            <div className="edit-additional-container">
              <form onSubmit={handleSubmit(submitFn)}>
                <div className="form-group">
                  <textarea
                    name="additional_info"
                    id="additional_info"
                    ref={register({ maxLength: 100 })}
                    row="5"
                    className="form-control"
                    defaultValue={additionalInfo}
                  ></textarea>
                  <span className="error error-text">
                    {errors.additional_info &&
                      errors.additional_info.type === "maxLength" &&
                      "Maximum allowed characters is 100."}
                  </span>
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    disabled={progress === true ? true : false}
                    className="btn btn-primary btn-sm"
                  >
                    {progress === false && "Save"}
                    {progress === true && <><Spinner size="sm"/>{" "}Saving </>}
                  </button>
                  <button
                    className="btn btn-dark btn-sm ml-1"
                    type="button"
                    disabled={progress === true ? true : false}
                    onClick={() => {
                      setConfirmCancel(true);
                    }}
                  >
                    Back
                  </button>
                </div>
                {error !== null && <div className="error-text"> {error} </div>}
              </form>
            </div>
            <ConfirmCancel
              onYes={() => {
                handleSubmit(submitFn)();
              }}
              progress={progress}
              onNo={() => {
                setShowEdit(false);
                setConfirmCancel(false);
              }}
              modal={confirmCancel}
              promptText={`Additional details has not been saved.
                 Do you want to save?`}
            />
          </>
        )}
      </div>
    </>
  );
  return JSX;
}
